export const enableScroll = (target: HTMLElement | null): void => {
  if (!target) {
    scrollLock.enablePageScroll();
  } else {
    const simplebarWrapper = target.querySelector<HTMLElement>(
      ".simplebar-content-wrapper"
    );

    if (simplebarWrapper) {
      scrollLock.enablePageScroll(simplebarWrapper);
    } else {
      scrollLock.enablePageScroll(target);
    }
  }
};
